export default {
  noActiveJob: 'Keine aktive Chargen gefunden',
  pinnedSensorModalHeader: 'Wähle angepinnte Sensoren aus',
  pinnedSensorListHeadline: 'Angepinnte Sensoren',
  jobTableHeader: 'Laufende Charge im ausgewählten Zeitraum',
};
